import * as React from 'react';

function SvgIconClock(props) {
  return (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#icon-clock_svg__a)" fill="#6B92F3">
        <path d="M7 .875a6.125 6.125 0 100 12.25A6.125 6.125 0 007 .876zm0 11.21a5.087 5.087 0 11.002-10.173A5.087 5.087 0 017 12.086z" />
        <path d="M9.389 8.73l-1.95-1.41V3.936a.11.11 0 00-.11-.11h-.657a.11.11 0 00-.11.11v3.765a.11.11 0 00.046.09l2.261 1.648a.11.11 0 00.153-.023l.391-.533a.11.11 0 00-.024-.153z" />
      </g>
      <defs>
        <clipPath id="icon-clock_svg__a">
          <path fill="#fff" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgIconClock;
